import { Row } from '@tanstack/react-table';
import CheckboxInput from '#/components/Checkbox';
import { CheckboxContainer } from './common';

type SelectorCellProps<T> = {
  row: Row<T>;
};

/**
 * Recursively check if there is any child leaf row that is selected
 */
const hasSomeSubRowChecked = <T,>(rows: Row<T>[] | undefined): boolean => {
  return Boolean(
    rows?.some((row) =>
      row.subRows.length > 0
        ? hasSomeSubRowChecked(row.subRows)
        : row.getIsSelected(),
    ),
  );
};

/**
 * Recursively check if all child leaf rows are selected
 */
const hasAllSubChecked = <T,>(rows: Row<T>[] | undefined): boolean => {
  return Boolean(
    rows?.every((row) =>
      row.subRows.length > 0
        ? hasAllSubChecked(row.subRows)
        : row.getIsSelected(),
    ),
  );
};

const SelectorCell = <T,>({ row }: SelectorCellProps<T>) => {
  const isSomeChecked = hasSomeSubRowChecked(row.subRows);
  const isSubChecked = hasAllSubChecked(row.subRows);

  const toggleSelected = () => row.toggleSelected();

  return (
    <CheckboxContainer>
      <CheckboxInput
        dataTestId="selector-checkbox"
        onCheck={toggleSelected}
        indeterminate={isSomeChecked}
        isChecked={isSubChecked}
      />
    </CheckboxContainer>
  );
};

export default SelectorCell;
